import { ComponentProps } from "react";
import { Controller } from "react-hook-form";
import { twMerge } from "tailwind-merge";
import { Input } from "../../Atoms/Inputs/Input";
import { SimpleSelect } from "../../Atoms/Selects/SimpleSelect";
import { MessageErroFormV2 } from "../../Atoms/MessageErroFormV2";
import { ISelectOptions } from "../../../types/inputs";
import {
  IFormDeliveryConcessionaireV2Values,
  useFormDeliveryConcessionaireV2,
} from "./useFormDeliveryConcessionaireV2";

interface IFormDeliveryConcessionaireV2Props extends ComponentProps<"form"> {
  onSubmitForm: (data: IFormDeliveryConcessionaireV2Values) => void;
}

export const FormDeliveryConcessionaireV2 = ({
  onSubmitForm,
  className,
  ...rest
}: IFormDeliveryConcessionaireV2Props) => {
  const { control, errors, handleSubmit, register, concessionariasOptions } =
    useFormDeliveryConcessionaireV2();

  return (
    <form
      {...rest}
      onSubmit={handleSubmit(onSubmitForm)}
      className={twMerge(
        "w-full mx-auto grid grid-cols-2 sm:grid-cols-6 gap-x-4 gap-y-8",
        className,
      )}
    >
      <div className="col-span-2 sm:col-span-6">
        <Input
          id="nome"
          data-error={!!errors?.nome}
          {...register("nome")}
          label="Nome"
          required
        />
        {errors?.nome && (
          <MessageErroFormV2>{errors.nome.message}</MessageErroFormV2>
        )}
      </div>

      <div className="col-span-2 sm:col-span-3">
        <Input
          id="telefone"
          data-error={!!errors?.telefone}
          {...register("telefone")}
          label="Telefone"
          required
          maxLength={15}
        />
        {errors?.telefone && (
          <MessageErroFormV2>{errors.telefone.message}</MessageErroFormV2>
        )}
      </div>

      <div className="col-span-2 sm:col-span-3">
        <Controller
          control={control}
          name="uuidConcessionaria"
          render={({ field: { onChange, value } }) => (
            <SimpleSelect
              id="concessionaria"
              label="Concessionária"
              required
              data-error={!!errors?.uuidConcessionaria}
              options={concessionariasOptions}
              value={concessionariasOptions.find((i) => i.value === value) || null}
              onChange={(e: ISelectOptions) => onChange(e?.value)}
            />
          )}
        />
        {errors?.uuidConcessionaria && (
          <MessageErroFormV2>
            {errors.uuidConcessionaria.message}
          </MessageErroFormV2>
        )}
      </div>
    </form>
  );
};
